@let it = product();
<mat-toolbar>
  <h1>Product</h1>
  <span class="spacer"></span>
  <div class="cell-actions">
    <button matMiniFab (click)="location.back()" matTooltip="Go back">
      <mat-icon>reply</mat-icon>
    </button>

    @if (it) {
      <button matIconButton matTooltip="Agreements" [routerLink]="['/app/agreements', it.ClientCode, it.JobNumber]">
        <mat-icon>assignment</mat-icon>
      </button>
    }

    <a matIconButton matTooltip="Open Knowledge Doc" target="_blank" [href]="kbLink">
      <mat-icon>menu_book</mat-icon>
    </a>
  </div>
</mat-toolbar>

@if (it) {
  <div class="grid">
    <section class="c-12 c-lg-8 opportunity-details">
      <mat-toolbar>
        <h2>{{ it.Title }}</h2>
        <span class="spacer"></span>
        <div class="cell-actions">
          @if (probablyHolded()) {
            <button
              matTooltip="No recent Jira worklogs found in the last 3 months."
              matIconButton
              class="mat-text-error"
            >
              <mat-icon>warning</mat-icon>
            </button>
          }
          @if (auth.isAdminOrEditor()) {
            <button matMiniFab (click)="edit()" [disabled]="pending()">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </mat-toolbar>

      <lcm-product-detail-table [product]="it"></lcm-product-detail-table>
    </section>

    <lcm-activity-stream class="c-12 c-lg-4" id="opportunity{{ +it.JobNumber || 0 }}" />

    <lcm-project-table class="c-12" [owner]="it" (updated)="reload()" />

    <lcm-extra-hours-table
      class="c-12"
      [pending]="pending()"
      property="UnchargeableHours"
      [owner]="it"
      [service]="productService"
      (removed)="reload()"
      (added)="reload()"
    />

    <lcm-extra-hours-table
      class="c-12"
      [pending]="pending()"
      property="ProfitableHours"
      [owner]="it"
      [service]="productService"
      (removed)="reload()"
      (added)="reload()"
    />

    <lcm-time-reporting-widget class="c-12" [project]="it" />
  </div>
} @else {
  <mat-spinner></mat-spinner>
}
